import { get, post } from '../../utils/http';

export const fetchProjectPosts = ({ accountId, branchId, projectId, token }) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/posts`, {
    pageSize: 20,
    token: token || 0
  });

export const addProjectPost = ({ accountId, branchId, projectId, ...params }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/posts`, params);

export const publishProjectFeed = ({ accountId, branchId, projectId, postId, ...params }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/posts/${postId}/publish`, params);

export const fetchProjectPostFilters = ({ accountId, branchId, projectId }) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/posts/filters`);

export const fetchProjectPostStats = ({ accountId, branchId, projectId, postId }) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/posts/${postId}/stats`);
